"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var environment_1 = require("@shared/types/environment");
var angular_1 = require("angular");
var lodash_1 = __importDefault(require("lodash"));
/**
 * Factory to keep track of whether edits are enabled for the currently loaded report.
 * Whether edits are enabled should be stored on the environment using the 'editing' key.
 * Ripsaw uses this env variable to determine whether to permit us to make saves.
 */
// @ts-ignore
// @ts-ignore
function EditAbilityManagerFactory(env, navigationService) {
    return {
        disable: disable,
        enable: enable,
        isEnabled: isEnabled,
        init: init
    };
    function init() {
        if (navigationService.isReadOnly) {
            disable();
        }
        else if (env.get(environment_1.ENV_VARS.IS_BATCH_GENERATION_IN_PROGRESS)) {
            disable();
        }
        else if (lodash_1.default.isUndefined(isEnabled())) {
            // don't enable edits if edits were disabled by somewhere else
            enable();
        }
    }
    function disable() {
        env.set(environment_1.ENV_VARS.EDITING, false);
    }
    function enable() {
        // this must be set so ripsaw lets us save
        env.set(environment_1.ENV_VARS.EDITING, true);
    }
    function isEnabled() {
        return env.get(environment_1.ENV_VARS.EDITING);
    }
}
(function (module) {
    module.factory('pr.editAbilityManager', [
        'rsEnvironment',
        'pr.navigationService',
        EditAbilityManagerFactory
    ]);
})(angular_1.module('qualtrics.pr'));
